// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"476":"93494fb2","491":"93494fb2"}[chunkId] + ".chunk.css";
};